import { Schema } from 'effect';

import { StringOptionalProperty } from '../primitive/string';

export const PageType = {
  home: 'home',
  category: 'category',
  info: 'info',
  blog: 'blog',
  product: 'product',
  checkout: 'checkout',
  purchase: 'purchase',
  brand: 'brand',
  account: 'account',
  search: 'search',
} as const;

/**
 * Page type literal for GTM page view tracking
 */
export const GtmPageType = Schema.Literals([
  PageType.home,
  PageType.category,
  PageType.info,
  PageType.blog,
  PageType.product,
  PageType.checkout,
  PageType.purchase,
  PageType.brand,
  PageType.account,
  PageType.search,
]);

export type GtmPageType = Schema.Schema.Type<typeof GtmPageType>;

/**
 * User type literal for GTM page view tracking
 */
export const GtmUserType = Schema.Literals(['Anonymous', 'Customer']);

export type GtmUserType = Schema.Schema.Type<typeof GtmUserType>;

/**
 * First event - Page and user data (no event field)
 */
export const GtmPageDataEventSchema = Schema.Struct({
  page: Schema.Struct({
    type: GtmPageType,
    breadcrumbs: StringOptionalProperty,
  }),
  user: Schema.Struct({
    type: GtmUserType,
    id: StringOptionalProperty,
    name: StringOptionalProperty,
    email: StringOptionalProperty,
    phone: StringOptionalProperty,
    address: Schema.optional(
      Schema.Struct({
        city: StringOptionalProperty,
        street: StringOptionalProperty,
      })
    ),
  }),
}).annotate({ identifier: 'GtmPageDataEventSchema' });

export type GtmPageDataEvent = Schema.Schema.Type<typeof GtmPageDataEventSchema>;

/**
 * Second event - Simple page view trigger
 */
export const GtmPageViewEventSchema = Schema.Struct({
  event: Schema.Literal('track.page_view'),
}).annotate({ identifier: 'GtmPageViewEventSchema' });

export type GtmPageViewEvent = Schema.Schema.Type<typeof GtmPageViewEventSchema>;
